/** @jsx jsx */
import { memo } from "react";
import { jsx, SxStyleProp } from "theme-ui";

interface Props {
  caption?: string | null;
  children: React.ReactNode;
  credits?: string | null;
  customsx?: SxStyleProp;
  shadow?: boolean;
}

const Figure: React.FC<Props> = ({
  caption,
  children,
  credits,
  customsx,
  shadow = true,
}) => {
  return (
    <figure
      sx={{
        display: ["block", "block", "block", "inline-block"],
        lineHeight: 0,
        margin: 0,
        maxWidth: "100%",
        padding: 0,
        position: "relative",
        "::before": shadow
          ? {
              backgroundColor: "accent",
              content: [undefined, undefined, undefined, '""'],
              height: "100%",
              left: 0,
              position: "absolute",
              top: 0,
              width: "100%",
              transform: "translate(3%, 3%)",
            }
          : undefined,
        ...customsx,
      }}
    >
      {children}
      {caption && (
        <figcaption
          sx={{
            color: "accent",
            fontSize: 0,
            left: [undefined, undefined, undefined, "-1.75em"],
            lineHeight: "1.5",
            position: "absolute",
            top: [undefined, undefined, undefined, 0],
            bottom: ["100%", "100%", "100%", undefined],
            transform: [
              undefined,
              undefined,
              undefined,
              "rotate(-90deg) translate(-100%, -100%)",
            ],
            transformOrigin: "top left",
            "::before": {
              color: "accent",
              content: '"—"',
              marginRight: ".75ex",
            },
          }}
        >
          {caption}
        </figcaption>
      )}
      {credits && (
        <span
          sx={{
            bottom: ".5rem",
            color: "#fff",
            fontSize: "8px",
            fontStyle: "italic",
            left: ".5rem",
            lineHeight: "1.5",
            position: "absolute",
            right: ".5rem",
            textAlign: "right",
            textShadow: "1px 1px 0 rgba(0,0,0,.25)",
          }}
        >
          {credits}
        </span>
      )}
    </figure>
  );
};

export default memo(Figure);
